import { createFileRoute } from "@tanstack/react-router";
import { ResidentUpdatesPage } from "@/components/app/portal/pages/resident-updates-page";

export const Route = createFileRoute("/family-portal/$residentId/updates")({
  head: () => ({ meta: [{ title: "Updates | People AI" }] }),
  component: FamilyUpdates,
});

function FamilyUpdates() {
  const { residentId } = Route.useParams();
  return <ResidentUpdatesPage kind="family" residentId={residentId} />;
}
